import { IconAssets } from '../../utils/enums/assets';
import { Scenes } from '../../utils/enums/scenes';
import { loadGameAssets } from '../../utils/helpers/loadGameAssets';
import { GameScene } from '../classes/GameScene';
import { UI } from '../ui/ui';

export class StartMenu extends GameScene {
  constructor() {
    super(Scenes.START_MENU);
  }

  init(data) {
    this.user = data.user;
    this.registry.set('isMuted', false);
  }

  preload() {
    loadGameAssets(this);
  }

  create() {
    UI.images.Background(this);

    UI.buttons.PlayBtn(this, () => {
      this.scene.stop().start(Scenes.GAME, { user: this.user });
    });

    UI.buttons.ScoreBtn(this, () => {
      this.scene.stop().start(Scenes.SCORE, { user: this.user });
    });

    UI.icons.HomeIcon(this, { interactive: true }).on('pointerdown', () => {
      this.scene.stop();
      this.scene.start(Scenes.EXIT_GAME, { user: this.user });
    });

    this.toggleSoundBtn();
    UI.icons.FullScreenIcon(this);

    this.scene.stop(Scenes.LOADING);
  }

  toggleSoundBtn(): void {
    let isMuted = this.registry.get('isMuted');
    const soundIcon = UI.icons.SoundIcon(this, { interactive: true }).setPosition(120, 45);

    soundIcon.on('pointerdown', () => {
      if (isMuted) {
        this.sound.resumeAll();
        soundIcon.setTexture(IconAssets.SOUND_ICON);
      } else {
        this.sound.pauseAll();
        soundIcon.setTexture(IconAssets.MUTE_SOUND_ICON);
      }

      isMuted = !isMuted;
      this.registry.set('isMuted', isMuted);
    });
  }
}
